(function () {
  function initInfiniteScroll() {
    const container = document.querySelector('.product-loop.grid__wrapper, #CollectionProductGrid .product-loop');
    const pagination = document.querySelector('.pagination__wrapper');

    if (!container || !pagination) return;

    let nextUrl = pagination.querySelector('a.paginate-buttons[aria-label="Next"]')?.href;
    if (!nextUrl) return;

    pagination.style.display = 'none';

    let loading = false;

    const loader = document.createElement('div');
    loader.innerHTML = '<p style="text-align:center;padding:30px;font-size:14px;">Yükleniyor...</p>';
    loader.style.display = 'none';
    container.after(loader);

    function loadMore() {
      if (loading || !nextUrl) return;
      const loaderRect = loader.getBoundingClientRect();
      if (loaderRect.top > window.innerHeight + 400) return;

      loading = true;
      loader.style.display = 'block';

      fetch(nextUrl)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.product-loop__item');
          newItems.forEach(item => container.appendChild(item));

          const newNext = doc.querySelector('a.paginate-buttons[aria-label="Next"]');
          nextUrl = newNext ? newNext.href : null;

          loader.style.display = 'none';
          loading = false;

          if (!nextUrl) loader.remove();
        })
        .catch(() => {
          loader.style.display = 'none';
          loading = false;
        });
    }

    window.addEventListener('scroll', loadMore, { passive: true });
    loadMore(); // ilk yüklemede de kontrol et
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();
